import React from "react";
import TutorialWalkthrough from "./TutorialWalthrough";

interface TutorialStep {
  target: string;
  title: string;
  content: string;
  position: "top" | "right" | "bottom" | "left";
  offset?: {
    x?: number;
    y?: number;
  };
}

const TutorialButton: React.FC = () => {
  const tripTutorialSteps: TutorialStep[] = [
    {
      target: '[data-tutorial="basic-info"]',
      title: "Trip Header Bar",
      content:
        "Here you can see your trip name, the added participants, the tutorial, and the publish button, which allows you to share your trip with others!",
      position: "bottom" as const,
    },
    {
      target: '[data-tutorial="trip-users"]',
      title: "Manage Participants",
      content:
        "Click this button to add or remove trip participants and manage their permissions.",
      position: "bottom" as const,
    },
    {
      target: '[data-tutorial="edit-trip"]',
      title: "Edit Trip Details",
      content:
        "Click here to share your trip with others, change the privacy settings, and edit other details.",
      position: "bottom" as const,
    },
    {
      target: '[data-tutorial="location-sidebar"]',
      title: "Trip Locations",
      content:
        "The trip sidebar shows all the destinations in your trip. Click the flags to see the overview of each location whilst clicking the airplanes shows you how you'll get between places!",
      position: "right" as const,
    },
    {
      target: '[data-tutorial="location-item"]',
      title: "Destination",
      content:
        "Click on any destination to view and edit its details. The country flag helps you quickly identify each location.",
      position: "right" as const,
      offset: { x: -1200, y: 0 },
    },
    {
      target: '[data-tutorial="add-destination"]',
      title: "Add New Destination",
      content:
        "Click this button to add a new destination to your trip itinerary.",
      position: "left",
      offset: { x: -2, y: -100 }, // Move the card 100px up
    },
    {
      target: '[data-tutorial="overview-accommodation"]',
      title: "Your Accommodation",
      content: "This section shows where you'll be staying for each location.",
      position: "right",
      offset: { x: -200, y: -40 }, // Move the card 100px up
    },
    {
      target: '[data-tutorial="overview-notifications"]',
      title: "Notifications",
      content:
        "This section shows all the new things that have happened in a location, ensuring you're all up to date!",
      position: "left",
      offset: { x: 450, y: -40 }, // Move the card 100px up
    },
    {
      target: '[data-tutorial="overview-destination-users"]',
      title: "Friends and Family!",
      content: "This is where you can add friends & family to each location.",
      position: "right",
      offset: { x: -200, y: -40 }, // Move the card 100px up
    },
    {
      target: '[data-tutorial="overview-booking-progress"]',
      title: "Booking Progress",
      content:
        "This is a summary of how you're going with your plans so far. The status of transport, accommodation and experiences are all here.",
      position: "right",
      offset: { x: -200, y: -40 }, // Move the card 100px up
    },
    {
      target: '[data-tutorial="overview-budget"]',
      title: "Budget",
      content: "Click here to see a breakdown of your budget for the location!",
      position: "right",
      offset: { x: -100, y: -100 }, // Move the card 100px up
    },
    {
      target: '[data-tutorial="overview-weather"]',
      title: "Weather",
      content:
        "Click here to see the weather for each location! This is a great way to plan your trip!",
      position: "right",
      offset: { x: -200, y: -120 }, // Move the card 100px up
    },
    {
      target: '[data-tutorial="overview-map"]',
      title: "The Map",
      content:
        "Here shows the map of each day. Where you're staying and what you're doing!",
      position: "top",
      offset: { x: -250, y: -40 }, // Move the card 100px up
    },
    {
      target: '[data-tutorial="overview-total-schedule"]',
      title: "The Schedule",
      content:
        "Finally, we have our location schedule on the right! This shows a breakdown of all the things you're gonna get up to! Now click the Schedule, Accommodation and Tora tabs to get going!",
      position: "left",
      offset: { x: -300, y: -120 }, // Move the card 100px up
    },
  ];

  const handleTutorialComplete = () => {
    localStorage.setItem("tripTutorialCompleted", "true");
  };

  return (
    <div className="ml-2">
      <TutorialWalkthrough
        steps={tripTutorialSteps as TutorialStep[]}
        onComplete={handleTutorialComplete}
      />
    </div>
  );
};

export default TutorialButton;
